import React, { useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import Select from 'react-select';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { useNavigate } from 'react-router-dom';
import { customStyles } from '../../../../../HelperFunctions';
import axios from 'axios';
import { adminMainUrl } from '../../../../../Config';
import { useDispatch, useSelector } from 'react-redux';
import { getAirlineAddressByAirlineList, getIATAAgentAddressByIATAAgentList } from '../../../../../Redux/action/MasterAction';
import Beatloader from '../../../../../Common/Loaders/Beatloader';
import { getFFAirExportMAWBStockDetail, getFFAirExportMAWBStockList } from '../../../../../Redux/action/FreightForwarding/Console/FFAirExpAction';


const EditAirExpMAWBStockOffcanvas = ({
    mawbStock_id,
    show,
    handleClose,
    IATAAgentOptions,
    airlineOptions,
    token,
    user_id,
    refresh
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [disableSubmit, setDisableSubmit] = useState(false);
    const [showAirlineDiv, setShowAirlineDiv] = useState(false);
    const [showIATADiv, setShowIATADiv] = useState(false);

    let [airlineAddressOptions, setAirlineAddressOptions] = useState([]);
    let [IATAAgentAddressOptions, setIATAAgentAddressOptions] = useState([]);

    useEffect(() => {
        if (mawbStock_id) {
            dispatch(getFFAirExportMAWBStockDetail(token, user_id, mawbStock_id))
        }
    }, [mawbStock_id]);


    const {
        loadingFFAirExpMAWBStockDetail,
        FFAirExpMAWBStockDetail,
        FFAirExpMAWBStockDetailError
    } = useSelector(state => state.FFAirExpReducer);

    const {
        loadingAirlineAddressByAirlineList,
        AirlineAddressByAirlineList,
        AirlineAddressByAirlineListError,

        loadingIATAAgentAddressByIATAAgentList,
        IATAAgentAddressByIATAAgentList,
        IATAAgentAddressByIATAAgentListError
    } = useSelector(state => state.MasterReducer);

    useEffect(() => {
        if (AirlineAddressByAirlineList) {
            let arr = [];
            AirlineAddressByAirlineList.map(v => { arr.push({ value: v.id, label: v.address }) });
            setAirlineAddressOptions(arr);
        }
    }, [AirlineAddressByAirlineList]);

    useEffect(() => {
        if (IATAAgentAddressByIATAAgentList) {
            let arr = [];
            IATAAgentAddressByIATAAgentList.map(v => { arr.push({ value: v.id, label: v.address }) });
            setIATAAgentAddressOptions(arr);
        }
    }, [IATAAgentAddressByIATAAgentList]);



    const initialValues = {
        party_type: "",
        stock_date: "",
        airline_id: 0,
        airline_address_id: 0,
        iata_agent_id: 0,
        iata_agent_address_id: 0,
        awb_airline_code: "",
        awb_first_four_digit: "",
        awb_three_digit: "",
        awb_last_check_digit: "",
        no_of_awb: "",
        last_stock_sequence_no: "",
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if(mawbStock_id){
                    values.id = mawbStock_id
                }else{
                    toast.error("ID is required");
                    return;
                }
                axios.post(`${adminMainUrl}/api/freight/forwarding/air/export/mawbstock/update`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            // resetForm();
                            refresh();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    useEffect(() => {
        if (FFAirExpMAWBStockDetail) {
            // console.log(FFAirExpMAWBStockDetail);
            formik.setFieldValue("party_type", FFAirExpMAWBStockDetail.party_type);
            formik.setFieldValue("stock_date", FFAirExpMAWBStockDetail.stock_date);
            formik.setFieldValue("airline_id", FFAirExpMAWBStockDetail.airline_id);
            formik.setFieldValue("airline_address_id", FFAirExpMAWBStockDetail.airline_address_id);
            formik.setFieldValue("awb_airline_code", FFAirExpMAWBStockDetail.awb_airline_code);
            formik.setFieldValue("awb_first_four_digit", FFAirExpMAWBStockDetail.awb_first_four_digit ? FFAirExpMAWBStockDetail.awb_first_four_digit.toString() : "");
            formik.setFieldValue("awb_three_digit", FFAirExpMAWBStockDetail.awb_three_digit ? FFAirExpMAWBStockDetail.awb_three_digit.toString() : "");
            formik.setFieldValue("awb_last_check_digit", FFAirExpMAWBStockDetail.awb_last_check_digit);
            formik.setFieldValue("no_of_awb", FFAirExpMAWBStockDetail.no_of_awb ? FFAirExpMAWBStockDetail.no_of_awb.toString():"");
            formik.setFieldValue("last_stock_sequence_no", FFAirExpMAWBStockDetail.last_stock_sequence_no);
        }
    }, [FFAirExpMAWBStockDetail])

    useEffect(() => {
        if (FFAirExpMAWBStockDetail) {
            formik.setFieldValue("iata_agent_id", FFAirExpMAWBStockDetail.iata_agent_id);
            formik.setFieldValue("iata_agent_address_id", FFAirExpMAWBStockDetail.iata_agent_address_id);
        }
    }, [FFAirExpMAWBStockDetail, IATAAgentAddressOptions, IATAAgentOptions]);

    useEffect(() => {
        if (formik.values.party_type) {
            if (formik.values.party_type == "AIRLINE") {
                setShowAirlineDiv(true);
                setShowIATADiv(false);
            } else if (formik.values.party_type == "IATA") {
                setShowAirlineDiv(true);
                setShowIATADiv(true);
                formik.setFieldValue("iata_agent_id", 0);
                formik.setFieldValue("iata_agent_address_id", 0);
            } else {
                setShowAirlineDiv(false);
                setShowIATADiv(false);
                formik.setFieldValue("airline_id", 0);
                formik.setFieldValue("airline_address_id", 0);
                formik.setFieldValue("iata_agent_id", 0);
                formik.setFieldValue("iata_agent_address_id", 0);
            }
        } else {
            setShowAirlineDiv(false);
            setShowIATADiv(false);
            formik.setFieldValue("airline_id", 0);
            formik.setFieldValue("airline_address_id", 0);
            formik.setFieldValue("iata_agent_id", 0);
            formik.setFieldValue("iata_agent_address_id", 0);
        }
    }, [formik.values.party_type]);

    useEffect(() => {
        if (formik.values.airline_id && airlineOptions.length) {
            let findOne = airlineOptions.find(v => v.value == formik.values.airline_id);
            let getAirline_no = findOne.airline_no;
            if (getAirline_no) {
                formik.setFieldValue("awb_airline_code", getAirline_no);
            } else {
                formik.setFieldValue("awb_airline_code", "");
            }
        } else {
            formik.setFieldValue("awb_airline_code", "");
        }
    }, [airlineOptions, formik.values.airline_id]);

    useEffect(() => {
        if (formik.values.airline_id) {
            dispatch(getAirlineAddressByAirlineList(token, user_id, formik.values.airline_id))
        } else {
            setAirlineAddressOptions([]);
        }
    }, [formik.values.airline_id]);

    useEffect(() => {
        if (formik.values.iata_agent_id) {
            dispatch(getIATAAgentAddressByIATAAgentList(token, user_id, formik.values.iata_agent_id))
        } else {
            setIATAAgentAddressOptions([]);
        }
    }, [formik.values.iata_agent_id]);

    //calucaltion of last numbers
    useEffect(() => {
        if (
            formik.values.awb_first_four_digit &&
            !isNaN(formik.values.awb_first_four_digit) &&
            formik.values.awb_three_digit &&
            !isNaN(formik.values.awb_three_digit) &&
            formik.values.awb_first_four_digit.length == 4 &&
            formik.values.awb_three_digit.length == 3
        ) {
            let number_for_remainder_string = formik.values.awb_first_four_digit + formik.values.awb_three_digit;
            let number_for_remainder = Number(number_for_remainder_string);
            let remainder = number_for_remainder % 7;
            formik.setFieldValue("awb_last_check_digit", remainder)
        } else {
            formik.setFieldValue("awb_last_check_digit", "");
        }
    }, [formik.values.awb_first_four_digit, formik.values.awb_three_digit]);

    useEffect(() => {
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit);
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb);
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb && formik.values.awb_airline_code );
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb && formik.values.awb_airline_code && formik.values.awb_last_check_digit );
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb && formik.values.awb_airline_code && formik.values.awb_last_check_digit && !isNaN(formik.values.awb_first_four_digit));
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb && formik.values.awb_airline_code && formik.values.awb_last_check_digit && !isNaN(formik.values.awb_first_four_digit) && !isNaN(formik.values.awb_three_digit) );
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb && formik.values.awb_airline_code && formik.values.awb_last_check_digit && !isNaN(formik.values.awb_first_four_digit) && !isNaN(formik.values.awb_three_digit) && !isNaN(formik.values.no_of_awb));
        // console.log(formik.values.awb_first_four_digit && formik.values.awb_three_digit && formik.values.no_of_awb && formik.values.awb_airline_code && formik.values.awb_last_check_digit && !isNaN(formik.values.awb_first_four_digit) && !isNaN(formik.values.awb_three_digit) && !isNaN(formik.values.no_of_awb) && formik.values.awb_first_four_digit.length == 4 && formik.values.awb_three_digit.length == 3);

        // console.log(formik.values.awb_first_four_digit)
        // console.log(formik.values.awb_three_digit)
        // console.log(formik.values.no_of_awb)
        // console.log(formik.values.awb_airline_code)
        // console.log(formik.values.awb_last_check_digit)

        if (
            formik.values.awb_first_four_digit &&
            formik.values.awb_three_digit &&
            formik.values.no_of_awb &&
            formik.values.awb_airline_code &&
            formik.values.awb_last_check_digit &&
            !isNaN(formik.values.awb_first_four_digit) &&
            !isNaN(formik.values.awb_three_digit) &&
            !isNaN(formik.values.no_of_awb) &&
            formik.values.awb_first_four_digit.length == 4 &&
            formik.values.awb_three_digit.length == 3
        ) {
            let combine_four_and_three_digits = Number(formik.values.awb_first_four_digit + formik.values.awb_three_digit);
            let add_noofawb_to_combine_four_and_three_digits = Number(formik.values.no_of_awb) - 1 + combine_four_and_three_digits;

            let add_noofawb_to_awb_last_check_digit = Number(formik.values.no_of_awb) - 1 + Number(formik.values.awb_last_check_digit);
            let get_remainder = add_noofawb_to_awb_last_check_digit % 7;

            let last_stock_sequence_no = `${formik.values.awb_airline_code}-${add_noofawb_to_combine_four_and_three_digits}${get_remainder}`;

            formik.setFieldValue("last_stock_sequence_no", last_stock_sequence_no);
        } else {
            formik.setFieldValue("last_stock_sequence_no", "");
        }
    }, [
        formik.values.awb_first_four_digit,
        formik.values.awb_three_digit,
        formik.values.no_of_awb,
        formik.values.awb_airline_code,
        formik.values.awb_last_check_digit,
    ]);


    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit MAWB Stock</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {
                        loadingFFAirExpMAWBStockDetail ?
                            <Beatloader />
                            :
                            <form onSubmit={formik.handleSubmit} >
                                <div className="row">
                                    <div className="col-md-6">
                                        <label htmlFor="party_type" className='form-label mb-0'>
                                            Party Type
                                        </label>
                                        <select
                                            className="form-control form-control-sm"
                                            id="party_type"
                                            name='party_type'
                                            value={formik.values.party_type}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        >
                                            <option value="">-Select an option-</option>
                                            <option value="AIRLINE">Airline</option>
                                            <option value="IATA">IATA</option>
                                        </select>
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="stock_date" className='form-label mb-0'>
                                            Stock Date
                                        </label>
                                        <input
                                            type="date"
                                            className="form-control form-control-sm"
                                            id="stock_date"
                                            name='stock_date'
                                            value={formik.values.stock_date}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        />
                                    </div>
                                    {showAirlineDiv && <>
                                        <div className="col-md-6">
                                            <label htmlFor="airline_id" className='form-label mb-0'>
                                                Airline
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    // placeholder="Select an option"
                                                    options={airlineOptions}
                                                    styles={customStyles}
                                                    name="airline_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('airline_id', option.value);
                                                        formik.setFieldValue('airline_address_id', 0);
                                                    }}
                                                    value={formik.values.airline_id ? airlineOptions.find(option => option.value == formik.values.airline_id || null) : null}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="airline_address_id" className='form-label mb-0'>
                                                Airline Address
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    // placeholder="Select an option"
                                                    options={airlineAddressOptions}
                                                    styles={customStyles}
                                                    name="airline_address_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('airline_address_id', option.value);
                                                    }}
                                                    value={formik.values.airline_address_id ? airlineAddressOptions.find(option => option.value == formik.values.airline_address_id || null) : null}
                                                />
                                            </div>
                                        </div>
                                    </>}
                                    {showIATADiv && <>
                                        <div className="col-md-6">
                                            <label htmlFor="iata_agent_id" className='form-label mb-0'>
                                                IATA
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    // placeholder="Select an option"
                                                    options={IATAAgentOptions}
                                                    styles={customStyles}
                                                    name="iata_agent_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('iata_agent_id', option.value);
                                                        formik.setFieldValue('iata_agent_address_id', 0);
                                                    }}
                                                    value={formik.values.iata_agent_id ? IATAAgentOptions.find(option => option.value == formik.values.iata_agent_id || null) : null}
                                                />
                                            </div>

                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="iata_agent_address_id" className='form-label mb-0'>
                                                IATA Address
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    // placeholder="Select an option"
                                                    options={IATAAgentAddressOptions}
                                                    styles={customStyles}
                                                    name="iata_agent_address_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('iata_agent_address_id', option.value);
                                                    }}
                                                    value={formik.values.iata_agent_address_id ? IATAAgentAddressOptions.find(option => option.value == formik.values.iata_agent_address_id || null) : null}
                                                />
                                            </div>
                                        </div>
                                    </>}
                                    <div className="col-md-2">
                                        <label htmlFor="awb_airline_code" className='form-label mb-0'>
                                            Airway Bill No.
                                        </label>
                                        <input
                                            type="text"
                                            // placeholder='Enter Airline Code'
                                            className="form-control form-control-sm"
                                            id="awb_airline_code"
                                            name='awb_airline_code'
                                            value={formik.values.awb_airline_code}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}
                                            maxLength={3}
                                            disabled
                                        />

                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="awb_first_four_digit" className='form-label mb-0'>
                                            First Four Digits
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            // placeholder='First Four Digits'
                                            id="awb_first_four_digit"
                                            name='awb_first_four_digit'
                                            value={formik.values.awb_first_four_digit}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}
                                            maxLength={4}
                                        />

                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="awb_three_digit" className='form-label mb-0'>
                                            Last Three Digits
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            // placeholder='Last Three Digits'
                                            id="awb_three_digit"
                                            name='awb_three_digit'
                                            value={formik.values.awb_three_digit}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}
                                            maxLength={3}
                                        />

                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="awb_last_check_digit" className='form-label mb-0'>
                                            Last Check Digit
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            // placeholder='Last Check Digit'
                                            id="awb_last_check_digit"
                                            name='awb_last_check_digit'
                                            value={formik.values.awb_last_check_digit}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}
                                            maxLength={1}
                                            disabled
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <label htmlFor="no_of_awb" className='form-label mb-0'>
                                            No. of AWB
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            // placeholder="No. of AWBs"
                                            id="no_of_awb"
                                            name='no_of_awb'
                                            value={formik.values.no_of_awb}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9]/g, '');
                                                event.target.value = value;
                                            }}
                                            maxLength={4}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="last_stock_sequence_no" className='form-label mb-0'>
                                            Last Stock Sequence No.
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control form-control-sm"
                                            // placeholder="No. of AWBs"
                                            id="last_stock_sequence_no"
                                            name='last_stock_sequence_no'
                                            value={formik.values.last_stock_sequence_no}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            disabled
                                        />
                                    </div>

                                </div>
                                <div className="row d-flex justify-content-end">
                                    <div className="col-md-6 d-flex justify-content-end">
                                        <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                            {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Update"}
                                        </button>
                                    </div>
                                </div>
                            </form>
                    }
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default EditAirExpMAWBStockOffcanvas